// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import './index.css';
import AppRoutes from './AppRoutes';
import reportWebVitals from './reportWebVitals';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>

    <HelmetProvider>
      <AppRoutes />
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
